

























import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import ConversationParticipantDto from '@/models/Conversations/ConversationParticipantDto';
import EntityType from '@/models/Shared/EntityType';
import { AppModule } from '@/store/modules/app';
import OpenEntityInCurrentWindowLink from '@/components/Shared/OpenEntityInCurrentWindowLink.vue';
import OpenEntityInNewWindowBtn from '@/components/Shared/OpenEntityInNewWindowBtn.vue';

@Component({
  components: { OpenEntityInCurrentWindowLink, OpenEntityInNewWindowBtn },
  name: 'ConversationParticipant',
})
export default class extends GiganautVue {

  entityType = EntityType;

	@Prop({required: true})
	conversationParticipant: ConversationParticipantDto;

  getUserAvatarUrl(conversationParticipant: ConversationParticipantDto) {
    return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/" + conversationParticipant.entityType.toString() + "/" + conversationParticipant.entityId + "/resized-100/" + conversationParticipant.avatar;
  }

  get agencyBrandName() {
    return AppModule.currentAgencyContext.brandName;
  } 
}
